import React from 'react';
import classnames from 'classnames';
import { withTheme } from '@ifit/themes/withTheme';
import './index.scss';

export interface IProps {
  className?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  themeClass?: string;
  title: string;
}

const QuickFind = ({
  className,
  onClick,
  themeClass,
  title,
  ...rest
}: IProps) => {
  return (
    <button
      onClick={onClick}
      className={classnames('mp-quick-find', themeClass, className)}
      data-testid="mp-quick-find"
      {...rest}
    >
      {title}
    </button>
  );
};

export default withTheme(QuickFind);
